/* eslint-disable */ import { memoEval, sceneEntityObjectPropertiesComponent, sceneEntityObjectRemoteMaterialOverrideComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const baseFourLegSeparateComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'baseTopLeft', true).withAlias('BaseFourLegSeparate').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$objectName
        ], ($fileUrl, $objectName)=>({
            fileUrl: $fileUrl,
            objectName: $objectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'baseBottomLeft', true).withAlias('BaseFourLegSeparate').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$objectName
        ], ($fileUrl, $objectName)=>({
            fileUrl: $fileUrl,
            objectName: $objectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'baseTopRight', true).withAlias('BaseFourLegSeparate').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$objectName
        ], ($fileUrl, $objectName)=>({
            fileUrl: $fileUrl,
            objectName: $objectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'baseBottomRight', true).withAlias('BaseFourLegSeparate').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$objectName
        ], ($fileUrl, $objectName)=>({
            fileUrl: $fileUrl,
            objectName: $objectName,
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'baseTopLeft', true).withAlias('BaseFourLegSeparate').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$offsetXTopLeft,
            self.$offsetZTopLeft,
            self.$height,
            self.$heightScaleZero,
            self.$heightScaleOne
        ], ($offsetXTopLeft, $offsetZTopLeft, $height, $heightScaleZero, $heightScaleOne)=>({
            offsetX: $offsetXTopLeft,
            offsetZ: $offsetZTopLeft,
            rotationY: Math.PI,
            morphTargetInfluences: {
                height: {
                    value: $height,
                    scaleZero: $heightScaleZero,
                    scaleOne: $heightScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'baseBottomLeft', true).withAlias('BaseFourLegSeparate').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$offsetXBottomLeft,
            self.$offsetZBottomLeft,
            self.$height,
            self.$heightScaleZero,
            self.$heightScaleOne
        ], ($offsetXBottomLeft, $offsetZBottomLeft, $height, $heightScaleZero, $heightScaleOne)=>({
            offsetX: $offsetXBottomLeft,
            offsetZ: $offsetZBottomLeft,
            rotationY: -1 * Math.PI / 2,
            morphTargetInfluences: {
                height: {
                    value: $height,
                    scaleZero: $heightScaleZero,
                    scaleOne: $heightScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'baseTopRight', true).withAlias('BaseFourLegSeparate').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$offsetXTopRight,
            self.$offsetZTopRight,
            self.$height,
            self.$heightScaleZero,
            self.$heightScaleOne
        ], ($offsetXTopRight, $offsetZTopRight, $height, $heightScaleZero, $heightScaleOne)=>({
            offsetX: $offsetXTopRight,
            offsetZ: $offsetZTopRight,
            rotationY: Math.PI / 2,
            morphTargetInfluences: {
                height: {
                    value: $height,
                    scaleZero: $heightScaleZero,
                    scaleOne: $heightScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'baseBottomRight', true).withAlias('BaseFourLegSeparate').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$offsetXBottomRight,
            self.$offsetZBottomRight,
            self.$height,
            self.$heightScaleZero,
            self.$heightScaleOne
        ], ($offsetXBottomRight, $offsetZBottomRight, $height, $heightScaleZero, $heightScaleOne)=>({
            offsetX: $offsetXBottomRight,
            offsetZ: $offsetZBottomRight,
            morphTargetInfluences: {
                height: {
                    value: $height,
                    scaleZero: $heightScaleZero,
                    scaleOne: $heightScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'baseTopLeft', true).withAlias('BaseFourLegSeparate').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$finishColor,
            self.$textureUrl,
            self.$normalMapUrl,
            self.$roughnessMapUrl,
            self.$aoMapUrl,
            self.$materialRoughness,
            self.$materialMetalness,
            self.$materialEnvMapIntensity,
            self.$materialSpecularIntensity,
            self.$materialNormalScale,
            self.$materialReflectivity,
            self.$separateLegRepeatX,
            self.$separateLegRepeatY
        ], ($fileUrl, $finishColor, $textureUrl, $normalMapUrl, $roughnessMapUrl, $aoMapUrl, $materialRoughness, $materialMetalness, $materialEnvMapIntensity, $materialSpecularIntensity, $materialNormalScale, $materialReflectivity, $separateLegRepeatX, $separateLegRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $finishColor,
            textureUrl: $textureUrl,
            normalMapUrl: $normalMapUrl,
            roughnessMapUrl: $roughnessMapUrl,
            aoMapUrl: $aoMapUrl,
            roughness: $materialRoughness,
            metalness: $materialMetalness,
            envMapIntensity: $materialEnvMapIntensity,
            specularIntensity: $materialSpecularIntensity,
            normalScale: $materialNormalScale,
            reflectivity: $materialReflectivity,
            repeatX: $separateLegRepeatX,
            repeatY: $separateLegRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'baseBottomLeft', true).withAlias('BaseFourLegSeparate').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$finishColor,
            self.$textureUrl,
            self.$normalMapUrl,
            self.$roughnessMapUrl,
            self.$aoMapUrl,
            self.$materialRoughness,
            self.$materialMetalness,
            self.$materialEnvMapIntensity,
            self.$materialSpecularIntensity,
            self.$materialNormalScale,
            self.$materialReflectivity,
            self.$separateLegRepeatX,
            self.$separateLegRepeatY
        ], ($fileUrl, $finishColor, $textureUrl, $normalMapUrl, $roughnessMapUrl, $aoMapUrl, $materialRoughness, $materialMetalness, $materialEnvMapIntensity, $materialSpecularIntensity, $materialNormalScale, $materialReflectivity, $separateLegRepeatX, $separateLegRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $finishColor,
            textureUrl: $textureUrl,
            normalMapUrl: $normalMapUrl,
            roughnessMapUrl: $roughnessMapUrl,
            aoMapUrl: $aoMapUrl,
            roughness: $materialRoughness,
            metalness: $materialMetalness,
            envMapIntensity: $materialEnvMapIntensity,
            specularIntensity: $materialSpecularIntensity,
            normalScale: $materialNormalScale,
            reflectivity: $materialReflectivity,
            repeatX: $separateLegRepeatX,
            repeatY: $separateLegRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'baseTopRight', true).withAlias('BaseFourLegSeparate').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$finishColor,
            self.$textureUrl,
            self.$normalMapUrl,
            self.$roughnessMapUrl,
            self.$aoMapUrl,
            self.$materialRoughness,
            self.$materialMetalness,
            self.$materialEnvMapIntensity,
            self.$materialSpecularIntensity,
            self.$materialNormalScale,
            self.$materialReflectivity,
            self.$separateLegRepeatX,
            self.$separateLegRepeatY
        ], ($fileUrl, $finishColor, $textureUrl, $normalMapUrl, $roughnessMapUrl, $aoMapUrl, $materialRoughness, $materialMetalness, $materialEnvMapIntensity, $materialSpecularIntensity, $materialNormalScale, $materialReflectivity, $separateLegRepeatX, $separateLegRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $finishColor,
            textureUrl: $textureUrl,
            normalMapUrl: $normalMapUrl,
            roughnessMapUrl: $roughnessMapUrl,
            aoMapUrl: $aoMapUrl,
            roughness: $materialRoughness,
            metalness: $materialMetalness,
            envMapIntensity: $materialEnvMapIntensity,
            specularIntensity: $materialSpecularIntensity,
            normalScale: $materialNormalScale,
            reflectivity: $materialReflectivity,
            repeatX: $separateLegRepeatX,
            repeatY: $separateLegRepeatY
        }))),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'baseBottomRight', true).withAlias('BaseFourLegSeparate').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$fileUrl,
            self.$finishColor,
            self.$textureUrl,
            self.$normalMapUrl,
            self.$roughnessMapUrl,
            self.$aoMapUrl,
            self.$materialRoughness,
            self.$materialMetalness,
            self.$materialEnvMapIntensity,
            self.$materialSpecularIntensity,
            self.$materialNormalScale,
            self.$materialReflectivity,
            self.$separateLegRepeatX,
            self.$separateLegRepeatY
        ], ($fileUrl, $finishColor, $textureUrl, $normalMapUrl, $roughnessMapUrl, $aoMapUrl, $materialRoughness, $materialMetalness, $materialEnvMapIntensity, $materialSpecularIntensity, $materialNormalScale, $materialReflectivity, $separateLegRepeatX, $separateLegRepeatY)=>({
            materialsToOverride: [
                'SupportMaterial'
            ],
            fileUrl: $fileUrl,
            materialName: 'SupportMaterial',
            color: $finishColor,
            textureUrl: $textureUrl,
            normalMapUrl: $normalMapUrl,
            roughnessMapUrl: $roughnessMapUrl,
            aoMapUrl: $aoMapUrl,
            roughness: $materialRoughness,
            metalness: $materialMetalness,
            envMapIntensity: $materialEnvMapIntensity,
            specularIntensity: $materialSpecularIntensity,
            normalScale: $materialNormalScale,
            reflectivity: $materialReflectivity,
            repeatX: $separateLegRepeatX,
            repeatY: $separateLegRepeatY
        })))
];

//# sourceMappingURL=base-four-leg-separate.js.map